import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import AddonsBlockData from "../../../Models/Content/AddonsBlockData";
import Addons from "./Addons";

export default class AddonsBlock extends EpiComponent<AddonsBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ["addons-block"];
    // if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    // if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(" ")}>
        <Addons iContent={this.props.data} context={this.getContext()} />
      </div>
    );
  }
}
